import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class ArcadeHighscoreForm extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("scene", null);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        this.item.setValue("confirmSend", false);
        this.item.setValue("name", "");
        this.item.setValue("currentCharacterIndex", 1);
        this.item.setValue("characters", ["»","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","Å","Ä","Ö","_","<"]);
    }

    setup() {
        {
            let text = Dbm.getRepositoryItem("game").controller.getText("Ditt namn:", 16, 0x000000); 
            text.position.x = 10;
            text.position.y = 15;
            this.item.pixiLayer.addChild(text);
        }

        let marker = new PIXI.Container()
        this.item.setValue("marker", marker);
        this.item.pixiLayer.addChild(marker);

        marker.position.x = 10;
        marker.position.y = 25;

        {
            let text = Dbm.getRepositoryItem("game").controller.getText("", 16, 0x000000); 
            text.position.x = 10;
            text.position.y = 26;
            this.item.pixiLayer.addChild(text);
            this.item.setValue("nameField", text);
        }
        
        {
            const box = new PIXI.Graphics();
            box.beginFill(0x000000);
            box.drawRect(0, 0, 9, 9);
            box.endFill();

            marker.addChild(box);

            let text = Dbm.getRepositoryItem("game").controller.getText("A", 16, 0xFFFFFF); 
            text.position.x = 1;
            text.position.y = 1;
            marker.addChild(text);
            
            this.item.setValue("markerCharacter", text);
        }
        
        let textBoxWidth = 240;
        let buttonHeight = 20;
        let buttonWidth = 64;
        let topPosition = 6;
        let margin = 5;
        
        let textHeight = 60;
        
        let startButton = new PIXI.Container();
        startButton.eventMode = "static";
        startButton.on("pointerdown", this._submit.bind(this));
        this.item.pixiLayer.addChild(startButton);
        this.item.setValue("startButton", startButton);

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        startButton.addChild(box);

        startButton.x = textBoxWidth-buttonWidth-margin;
        startButton.y = textHeight+topPosition+2*margin;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("SKICKA");
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);

        startButton.addChild(text);
        startButton.alpha = 0;
    }

    _submit() {

        this.item.scene.controller.arcadeSubmit(this.item.name);

        this.item.name = "";
        this.item.nameField.text = this.item.name;
        this.item.marker.position.x = this.item.nameField.width+10;

        this.item.markerCharacter.text = this.item.characters[1];
        this.item.currentCharacterIndex = 1;

        this.item.confirmSend = false;
        this.item.startButton.alpha = 0;
    }

    leftInput() {
        let currentCharacterIndex = (this.item.currentCharacterIndex+1)%this.item.characters.length;

        this.item.markerCharacter.text = this.item.characters[currentCharacterIndex];
        this.item.currentCharacterIndex = currentCharacterIndex;
        this.item.confirmSend = false;
        this.item.startButton.alpha = 0;
    }

    rightInput() {
        console.log("rightInput");
        console.log(this.item.currentCharacterIndex);
        if(this.item.currentCharacterIndex === 0) {
            console.log(this.item.confirmSend);
            if(this.item.name.length > 0) {
                if(this.item.confirmSend) {
                    this._submit();
                }
                else {
                    this.item.confirmSend = true;
                    this.item.startButton.alpha = 1;
                }
            }
            
        }
        else {
            let character = this.item.characters[this.item.currentCharacterIndex];
            if(character === "<") {
                this.item.name = this.item.name.substring(0, this.item.name.length-1);
                if(this.item.name.length === 0) {
                    this.item.currentCharacterIndex = 1;
                    this.item.markerCharacter.text = "A";
                }
            }
            else {
                this.item.name += character;
                this.item.currentCharacterIndex = 0;
                this.item.markerCharacter.text = "»";
            }

            this.item.nameField.text = this.item.name;

            this.item.marker.position.x = this.item.nameField.width+10;
        }
    }
}